import type { AuditEvent, Project } from '@p2b/contract';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ErrorNote } from '../../App.js';
import { api } from '../../api.js';
import { formatDate, useI18n } from '../../i18n.js';

export function AuditTab({ project }: { project: Project }) {
  const { t, lang } = useI18n();
  const events = useInfiniteQuery({
    queryKey: ['audit', project.id],
    initialPageParam: undefined as number | undefined,
    queryFn: ({ pageParam }) => api.audit(project.id, { limit: 100, before: pageParam }),
    getNextPageParam: (last: AuditEvent[]) =>
      last.length === 100 ? Number(last[last.length - 1]!.id) : undefined,
  });
  const rows = events.data?.pages.flat() ?? [];
  return (
    <div className="stack">
      <ErrorNote error={events.error} />
      <div className="sheet">
        <table className="dense stack-sm">
          <thead>
            <tr>
              <th>{t('when')}</th>
              <th>{t('who')}</th>
              <th className="hide-sm">{t('channel')}</th>
              <th>{t('action')}</th>
              <th className="hide-sm">{t('target')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.id} title={JSON.stringify(e.data)}>
                <td className="nowrap muted">{formatDate(e.at, lang)}</td>
                <td className="break">{e.actorEmail ?? e.actorUserId}</td>
                <td className="hide-sm">{e.via}</td>
                <td className="cell-full">
                  <div>{e.action}</div>
                  {e.target && <div className="muted break show-sm">{e.target}</div>}
                </td>
                <td className="break hide-sm muted">{e.target}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {events.hasNextPage && (
        <div>
          <button onClick={() => events.fetchNextPage()} disabled={events.isFetchingNextPage}>
            {t('older')}
          </button>
        </div>
      )}
    </div>
  );
}
